import {http, HttpResponse} from 'msw';
import {SetupServerApi} from 'msw/node';

import {
  PriceReportPreviewResponseBody,
  PriceReportResponseBody,
  CreatePriceReportResponseBody,
} from '../types';

export const priceReportsMock: PriceReportResponseBody[] = [
  {
    id: 'report-1',
    requestId: 'request-1',
    url: 'https://example.com/report-1.pdf',
    country: 'CZE',
    createdAt: '2024-01-15T10:00:00.000Z',
    createdBy: 'test-user-id',
  },
  {
    id: 'report-2',
    requestId: 'request-2',
    url: 'https://example.com/report-2.pdf',
    country: 'DEU',
    createdAt: '2024-01-10T10:00:00.000Z',
    createdBy: 'test-user-id',
  },
  {
    id: 'report-3',
    requestId: 'request-3',
    url: 'https://example.com/report-3.pdf',
    country: 'CZE',
    createdAt: '2024-01-05T10:00:00.000Z',
    createdBy: 'test-user-id',
  },
];

export const priceReportPreviewMock: PriceReportPreviewResponseBody = {
  stock: 15,
  sold: 25,
  recommendedSellingPrice: {
    amount: '25000',
    currency: 'CZK',
  },
};

export const createdPriceReportMock: CreatePriceReportResponseBody = {
  id: 'new-report-id',
  url: 'https://example.com/new-report.pdf',
  country: 'CZE',
  createdAt: new Date().toISOString(),
};

const getVehiclePriceReportsResponseInterceptor = (
  server: SetupServerApi,
  mockData: PriceReportResponseBody[] = priceReportsMock
) => server.use(http.get('*/dms/v*/vehicle/*/price-report', () => HttpResponse.json(mockData)));

const createVehiclePriceReportPreviewResponseInterceptor = (
  server: SetupServerApi,
  mockData: PriceReportPreviewResponseBody = priceReportPreviewMock
) =>
  server.use(
    http.post('*/dms/v*/vehicle/*/price-report-preview', () => HttpResponse.json(mockData))
  );

const createVehiclePriceReportResponseInterceptor = (
  server: SetupServerApi,
  mockData: CreatePriceReportResponseBody = createdPriceReportMock
) => server.use(http.post('*/dms/v*/vehicle/*/price-report', () => HttpResponse.json(mockData)));

export const vehicleApiMock = {
  priceReportsMock,
  priceReportPreviewMock,
  createdPriceReportMock,
  getVehiclePriceReportsResponseInterceptor,
  createVehiclePriceReportPreviewResponseInterceptor,
  createVehiclePriceReportResponseInterceptor,
};
